var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Image Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-288.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-icon",
    transform: "translate(288.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9109926,2.335 L12.91,4.335 L15.665,4.335 L15.665,14.665 L0.335,14.665 L0.335,4.335 L3.089,4.335 L4.0890074,2.335 L11.9109926,2.335 Z M11.089,3.665 L4.91,3.665 L3.9109926,5.665 L1.665,5.665 L1.665,13.335 L14.335,13.335 L14.335,5.665 L12.0890074,5.665 L11.089,3.665 Z M8,5.835 C9.60991005,5.835 10.915,7.14008995 10.915,8.75 C10.915,10.35991 9.60991005,11.665 8,11.665 C6.39008995,11.665 5.085,10.35991 5.085,8.75 C5.085,7.14008995 6.39008995,5.835 8,5.835 Z M8,7.165 C7.12462867,7.165 6.415,7.87462867 6.415,8.75 C6.415,9.62537133 7.12462867,10.335 8,10.335 C8.87537133,10.335 9.585,9.62537133 9.585,8.75 C9.585,7.87462867 8.87537133,7.165 8,7.165 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.8d496073.svg";
export { ForwardRef as ReactComponent };